import {Component} from '@angular/core';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {AppConstants} from "../../../shared/constants/app-constant";
import {Subscription} from "rxjs";


@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone : false,
})
export class HeaderComponent {
    courses = AppConstants.courses;
    isMobileMenuOpen = false;
    private routerSubscription: Subscription;
    isModalOpen = false;
    isModalVisible = false;
    isModalOpenedByButton = false;
    hasModalOpened = false;
    constructor(private router: Router) {}


    ngOnInit() {
        this.routerSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd && !this.isModalOpenedByButton) {
                setTimeout(() => {
                    this.openModal();
                    this.hasModalOpened = true;
                }, 3000);
            }
        });
        if (performance.navigation.type === 1 && !this.isModalOpenedByButton) {
            setTimeout(() => {
                this.openModal();
                this.hasModalOpened = true;

            }, 3000);
        }
    }

    ngOnDestroy() {
        if (this.routerSubscription) {
            this.routerSubscription.unsubscribe();
        }
    }
    toggleMobileMenu() {
        this.isMobileMenuOpen = !this.isMobileMenuOpen;
    }

    openModal() {
        this.isModalOpen = true;
        setTimeout(() => {
            this.isModalVisible = true;
        }, 10);
    }

    closeModal() {
        this.isModalVisible = false;
        setTimeout(() => {
            this.isModalOpen = false;
        }, 500);

    }
    onTransitionEnd() {
        if (!this.isModalVisible) {
            this.isModalOpen = false;
        }
    }

    formSubmission(event: any) {
        if (event) {
            this.closeModal();
        }
    }
}
